export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '用户登录日志';
